document.addEventListener('DOMContentLoaded', function() {
  const tabButtons = document.querySelectorAll('.mega-menu__tab-button');

  function switchTab(button) {
    // Find the closest mega-menu__tabs container
    const tabsContainer = button.closest('.mega-menu__tabs');
    if (!tabsContainer) return;

    // Get all buttons and panels within this container
    const containerButtons = tabsContainer.querySelectorAll('.mega-menu__tab-button');
    const containerPanels = tabsContainer.querySelectorAll('.mega-menu__tab-panel');

    // Remove active class from all buttons and panels in this container
    containerButtons.forEach(btn => {
      btn.classList.remove('active');
      btn.setAttribute('aria-selected', 'false');
    });
    containerPanels.forEach(panel => {
      panel.classList.remove('active');
    });

    // Add active class to clicked button and corresponding panel
    const tabIndex = button.getAttribute('data-tab');
    button.classList.add('active');
    button.setAttribute('aria-selected', 'true');
    
    const activePanel = tabsContainer.querySelector(`.mega-menu__tab-panel[data-tab="${tabIndex}"]`);
    if (activePanel) {
      activePanel.classList.add('active');
    }
  }

  // Add click event listeners to tab buttons
  tabButtons.forEach(button => {
    button.addEventListener('click', () => switchTab(button));
  });
});

document.querySelectorAll('details[trigger="hover"]').forEach((details) => {
  const trigger = details.querySelector('summary');
  const megaMenu = details.querySelector('.mega-menu');
  const dropdownMenu = details.querySelector('.dropdown-menu');
  let hoverTimeout;
  let closeMenuTimeout;

  // Function to close all other open menus
  const closeOtherMenus = () => {
    document.querySelectorAll('details[trigger="hover"]').forEach((otherDetails) => {
      if (otherDetails !== details && !otherDetails.contains(document.activeElement)) {
        otherDetails.removeAttribute('open');
        const otherMegaMenu = otherDetails.querySelector('.mega-menu');
        const otherDropdownMenu = otherDetails.querySelector('.dropdown-menu');

        if (otherMegaMenu) otherMegaMenu.style.opacity = '0';
        if (otherDropdownMenu) otherDropdownMenu.style.opacity = '0';
      }
    });
  };

  const openMenu = () => {
    closeOtherMenus();
    details.setAttribute('open', 'true');
    if (megaMenu) megaMenu.style.opacity = '1';
    if (dropdownMenu) dropdownMenu.style.opacity = '1';
  };

  const closeMenu = () => {
    if (megaMenu) megaMenu.style.opacity = '0';
    if (dropdownMenu) dropdownMenu.style.opacity = '0';
    setTimeout(() => details.removeAttribute('open'), 200);
  };

  if (trigger) {
    trigger.addEventListener('mouseenter', openMenu);
    details.addEventListener('mouseleave', () => {
      closeMenuTimeout = setTimeout(closeMenu, 1000);
    });
    details.addEventListener('mouseenter', () => {
      clearTimeout(closeMenuTimeout);
    });

    // Keyboard: open on Enter/Space, close on Escape
    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openMenu();
      } else if (event.key === 'Escape') {
        closeMenu();
      }

      // Open/close with Up/Down arrows
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        openMenu();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        closeMenu();
      }
    });

    // Prevent closing when interacting with submenu
    details.addEventListener('keydown', (event) => {
      if ((event.key === 'Enter' || event.key === ' ') && event.target.closest('.mega-menu, .dropdown-menu')) {
        event.stopPropagation();
      }
    });
  }
});

// Product Carousel Tabs section: START
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".product-carousel-tabs").forEach(function(section) {
    const tabButtons = section.querySelectorAll(".tab-link");
    const tabContents = section.querySelectorAll(".tab-content");

    tabButtons.forEach(function(btn) {
      btn.addEventListener("click", function() {
        const tabId = btn.dataset.tab;

        // Reset active classes inside this section only
        tabButtons.forEach(b => b.classList.remove("active"));
        tabContents.forEach(c => c.classList.remove("active"));

        // Activate clicked
        btn.classList.add("active");
        section.querySelector(`#tab-${tabId}`).classList.add("active");
      });
    });
  });
});
// Product Carousel Tabs section: END